<template>
  <ux-form
    ref="form"
    :data="formData"
    :rules="rules"
    width="500px"
    :colon="true"
    label-width="56px"
    data-automation="addUser"
  >
    <ux-form-item :label="$t('HT.addChannel.name')" prop="name">
      <ux-input
        v-model.trim()="formData.name"
        required
        :maxlength="20"
        :placeholder="$t('HT.addChannel.name.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addChannel.code')" prop="code">
      <ux-input
        v-model.trim()="formData.code"
        required
        :maxlength="50"
        :placeholder="$t('HT.addChannel.code.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addChannel.type')" prop="type">
      <ux-select
        v-model="formData.type"
        label="label"
        value="value"
        clearable
        :options="channelOption"
      ></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addChannel.type')" prop="priority">
      <ux-input
        v-model.trim()="formData.priority"
        :maxlength="4"
        required
        :placeholder="$t('HT.addChannel.priority.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.apiStepOne.remark')" start>
      <ux-input
        v-model.trim()="formData.remark"
        type="textarea"
        show-word-limit
        :maxlength="100"
        resize="none"
        :autosize="{ minRows: 3, maxRows: 6 }"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addChannel.open')" prop="disabled">
      <ux-switch v-model="formData.disabled" :active-value="false" :inactive-value="true" />
    </ux-form-item>
  </ux-form>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          name: '', //名称
          code: '', // 编码
          type: '', // 类型
          priority: '', //优先级
          remark: '', //描述
          disabled: false //启用
        };
      }
    }
  },
  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.channel(this),
      channelOption: [
        // 通道类型
        {
          label: this.$t('HT.options.channelType1'),
          value: 'SMS'
        },
        {
          label: this.$t('HT.options.messageType3'),
          value: 'TTS'
        }
      ]
    };
  }
};
</script>
